import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";

const HittaNatagare = lazy(() => import("@/pages/verktyg/HittaNatagare"));

export const Route = createFileRoute("/verktyg/hitta-natagare")({
  head: () => seoHead("/verktyg/hitta-natagare", { description: "Sök på postnummer och få fram elnätsbolaget som ansvarar för elnätet på din adress." }),
  component: () => <HittaNatagare />,
});
